<form [formGroup]="form" novalidate>
    <div class="row">
        <div class="column small-12">
            <h1 class="middle">{{ 'LOYALTY_MATAS_HEADLINE' | resource:'Passengers' }}</h1>
            <div id="logo" class="gutter" [innerHTML]="'LOYALTY_MATAS_IMAGES' | resource"></div>
            <div id="linkedCard" class="half-gutter" *ngIf="cardNumberExistInUserProfile" [innerHTML]="'LOYALTY_CARD_IS_LINKED' | resource"></div>
            <div id="unLinkedCard" class="half-gutter" *ngIf="!cardNumberExistInUserProfile" [innerHTML]="'LINK_LOYALTY_CARD' | resource"></div>
        </div>
    </div>
    <div class="row">
        <div class="column small-12 medium-12">
            <div class="row" *ngIf="cardNumberExistInUserProfile">
                <div class="column small-12 label">
                    <label for="cardNumber">{{ 'CARD_NUMBER' | resource }}</label>
                </div>
            </div>
            <div class="row" *ngIf="cardNumberExistInUserProfile">
                <div class="column small-12 medium-12 large-6">
                    <div class="row collapse inline-right">
                        <div class="column small-12 medium-8 field">
                            <input id="cardNumber" id="matasCardField" [disabled]="cardNumberExistInUserProfile" readonly numberOnly type="text" value="{{cardNumber}}" maxlength="13" name="matas_code_field"
                            />
                        </div>
                        <div class="column small-12 medium-4 label">
                            <sbw-button type="secondary" id="removeButton" name="remove_code_button" (clicked)="removeCardFromUserProfile()" [text]="'LOYALTY_REMOVE' | resource"></sbw-button>
                        </div>
                    </div>
                </div>

                <div class="column small-12 medium-12 large-6">
                    <div id="cardImage" [innerHTML]="'LOYALTY_MATAS_CARD' | resource"></div>
                </div>
            </div>

            <div class="row" *ngIf="!cardNumberExistInUserProfile">
                <div class="column small-12 label">
                    <label for="cardNumber">{{ 'CARD_NUMBER' | resource }}</label>
                </div>
                <div class="column small-12 medium-12 large-6 half-gutter">
                    <input value="" numberOnly tabIndex="-1" id="matasCardField" maxlength="13" formControlName="cardNumber" placeholder="{{ 'LOYALTY_MATAS_PLACEHOLDER' | resource }}"
                    />
                </div>
                <div class="column small-12 medium-12 large-6">
                    <div id="cardImage" [innerHTML]="'LOYALTY_MATAS_CARD' | resource"></div>
                </div>
            </div>
            <div class="row">
                <div class="column small-12 medium-12 large-6 half-gutter">
                    <span id="invalidCard" *ngIf="formCardNumber.dirty && formCardNumber.invalid && formCardNumber.errors.checkCardNumber && formCardNumber.value.length > 12"
                        class="field-validation-error">{{'VALIDATION_LOYALTYCARD_NOT_VALID' | resource}}</span>
                    <span id="validCard" *ngIf="formCardNumber.value && formCardNumber.dirty && formCardNumber.valid && formCardNumber.value.length > 12"
                        class="field-validation-ok">{{'VALIDATION_LOYALTYCARD_VALID' | resource}}</span>
                    <span id="cardCouldNotBeRemoved" *ngIf="couldNotRemoveCardFromProfile" class="field-validation-error">{{'VALIDATION_LOYALTYCARD_COULD_NOT_BE_REMOVED_FROM_PROFILE' | resource}}</span>
                </div>
            </div>
            <div class="row">
                <div class="column small-12">
                    <span id="matasAgreement">{{ 'LOYALTY_MATAS_AGREEMENT' | resource:'Passengers' }}</span>
                </div>
            </div>
        </div>
    </div>
</form>